export const SET_PRICETYPE = 'SET_PRICETYPE'
export const SET_RETAILER = 'SET_RETAILER'
